module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.listImg.length > 0) ? _c('swiper', {
    staticClass: "swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.listImg), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "swiper-item"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      },
      on: {
        "click": function($event) {
          _vm.click(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-white",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dbcd815!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/banner.vue
// module id = 830
// module chunks = 34